/**
 * Removes the `iss` query parameter from a URL (RFC 9207 authorization
 * server issuer identification). angular-oauth2-oidc cleans up `code`,
 * `scope`, `state` and `session_state` after the code-flow callback but
 * leaves `iss` behind (HYPE-1188).
 */
export function stripIssParam(url: string): string {
  const parsed = new URL(url);
  if (!parsed.searchParams.has('iss')) {
    return url;
  }
  parsed.searchParams.delete('iss');
  return parsed.toString();
}

export function removeIssFromBrowserUrl(): void {
  const cleaned = stripIssParam(window.location.href);
  if (cleaned !== window.location.href) {
    history.replaceState(null, window.name, cleaned);
  }
}
